"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@chakra-ui/utils");
const variantPrimary = props => (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.solid(props), {
    color: 'white',
    background: 'primary.400',
    _hover: {
        background: 'primary.500',
        _disabled: {
            background: 'gray.400',
        },
    },
    _active: {
        background: 'primary.700',
    },
    _disabled: {
        background: 'gray.400',
    },
});
const variantPrimaryInverted = props => (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.solid(props), {
    color: 'purple.400',
    background: 'white',
    _hover: {
        background: 'gray.200',
        _disabled: {
            color: 'white',
            background: 'gray.400',
        },
    },
    _active: {
        background: 'gray.300',
    },
    _disabled: {
        color: 'white',
        background: 'gray.400',
    },
});
const variantSecondary = props => (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.outline(props), {
    color: 'secondary.400',
    borderColor: 'secondary.400',
    _hover: {
        color: 'white',
        background: 'secondary.400',
        _disabled: {
            borderColor: 'gray.400',
            color: 'gray.400',
            background: 'gray.100',
        },
    },
    _active: {
        color: 'white',
        borderColor: 'secondary.700',
        background: 'secondary.700',
    },
    _disabled: {
        borderColor: 'gray.400',
        color: 'gray.400',
        background: 'gray.100',
    },
});
const variantSecondaryInverted = props => (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.outline(props), {
    color: 'white',
    borderColor: 'white',
    _hover: {
        color: 'purple.400',
        background: 'white',
        _disabled: {
            borderColor: 'white',
            color: 'gray.400',
            background: 'gray.100',
        },
    },
    _active: {
        color: 'purple.400',
        borderColor: 'gray.100',
        background: 'gray.100',
    },
    _disabled: {
        borderColor: 'gray.400',
        color: 'gray.400',
        background: 'gray.100',
    },
});
const variantTertiary = props => (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.ghost(props), {
    color: 'purple.400',
    _hover: {
        background: 'lilac.100',
        _disabled: {
            color: 'white',
            background: 'gray.400',
        },
    },
    _active: {
        background: 'purple.50',
    },
    _disabled: {
        color: 'white',
        background: 'gray.400',
    },
});
const variantTertiaryInverted = props => (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.ghost(props), {
    color: 'white',
    _hover: {
        color: 'purple.400',
        background: 'lilac.100',
        _disabled: {
            color: 'white',
            background: 'gray.400',
        },
    },
    _active: {
        color: 'purple.400',
        background: 'gray.100',
    },
    _disabled: {
        color: 'white',
        background: 'gray.400',
    },
});
const variantLink = {
    color: 'blue.500',
    _hover: {
        color: 'blue.600',
        _disabled: {
            color: 'gray.300',
        },
    },
    _active: {
        color: 'blue.700',
    },
    _disabled: {
        color: 'gray.500',
    },
};
const variantLinkInverted = {
    color: 'white',
    textDecoration: 'underline',
    _hover: {
        color: '#F0EDED',
        _disabled: {
            color: 'gray.300',
            textDecoration: 'underline',
        },
    },
    _active: {
        color: 'gray.300',
    },
    _disabled: {
        color: 'gray.300',
        textDecoration: 'underline',
    },
};
const baseStyle = {
    fontWeight: 'semibold',
    borderRadius: 'base',
};
const sizes = {
    sm: {
        height: 9,
        lineHeight: '22px',
    },
    md: {
        height: '42px',
        paddingX: 4,
    },
    lg: {
        height: 12,
        paddingX: 8,
        fontSize: 'md',
    },
};
const defaultProps = {
    variant: 'primary',
    size: 'md',
};
const variants = {
    primary: variantPrimary,
    secondary: variantSecondary,
    tertiary: variantTertiary,
    primaryInverted: variantPrimaryInverted,
    secondaryInverted: variantSecondaryInverted,
    tertiaryInverted: variantTertiaryInverted,
    link: variantLink,
    linkInverted: variantLinkInverted,
};
const ButtonStyle = {
    baseStyle,
    defaultProps,
    variants,
    sizes,
};
exports.default = ButtonStyle;
